import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { LazyLoadEvent } from "primeng/api";
import { ICanlyniadChwilio } from "../../modelau/canlyniad-chwilio";
import { IIaithTeitl } from "../../modelau/iaith/iaith-teitl";
import { IaithApiService } from "./iaith-api.service";
import { IaithRouterService } from "./iaith-router.service";
import { IaithStorfaService } from "./iaith-storfa.service";
import { IaithSystemService } from "./iaith-system.service";

@Injectable({
  providedIn: "root",
})
export class IaithService {
  constructor(
    private translateService: TranslateService,
    private iaithApiService: IaithApiService,
    private iaithStorfaService: IaithStorfaService,
    private iaithSystemService: IaithSystemService,
    private iaithRouterService: IaithRouterService,
  ) {
    this.translateService.addLangs([environment.iaith.cymraeg, environment.iaith.saesneg]);
  }

  newidIaithSystem(iaith?: string) {
    this.initializeIaith(iaith);
    this.iaithRouterService.newidIaithRouter(iaith);
  }

  initializeIaith(iaith?: string) {
    // Os ddim iaith wedi pasio, setio i default
    if (!iaith) {
      const iaithStorfa = this.iaithStorfaService.nol("iaith");

      if (iaithStorfa) {
        iaith = iaithStorfa;
      } else {
        iaith = environment.iaith.cymraeg;
      }
    }

    // Storio iaith i check dyfodol
    this.iaithStorfaService.setio("iaith", iaith);

    this.iaithSystemService.getTranslation(iaith).subscribe({
      next: (data) => {
        this.translateService.setTranslation(iaith, data, false);
      },
      error: (error) => {
        console.warn("Gwall nol cyfieithiad", error);
      },
    });
  }

  nolIaith() {
    return this.translateService.currentLang;
  }

  nolTestun(key: string | Array<string>, interpolateParams?: any): string | any {
    return this.translateService.instant(key, interpolateParams);
  }

  nolTestunHefoIaith(key: string | Array<string>): string | any {
    return this.translateService.instant(key, { value: this.nolIaith() === "cy" ? 1 : 2 });
  }

  nolTestunStream(key: string | Array<string>, interpolateParams?: any): Observable<string | any> {
    return this.translateService.stream(key, interpolateParams);
  }

  nolIeithoedd(): Observable<any> {
    return this.iaithApiService.nolTeitlauIaith();
  }

  chwilio(event: LazyLoadEvent): Observable<ICanlyniadChwilio> {
    return this.iaithApiService.chwilio(event);
  }

  get(id: number): Observable<IIaithTeitl> {
    return this.iaithApiService.nolTeitlIaithDrwyId(id);
  }

  diweddaru(iaith: IIaithTeitl): Observable<IIaithTeitl> {
    return this.iaithApiService.diweddaruTeitlIaith(iaith);
  }

  dileu(iaith: IIaithTeitl | number): Observable<IIaithTeitl> {
    return this.iaithApiService.dileu(iaith);
  }

  cyfieithuMathGwasanaeth(math: string): any {
    let testun = "ui.gwall";

    if (math === "ArchwiliadDiogelwch") {
      testun = "ui.archwiliaddiogelwch";
    } else if (math === "GwasanaethBlynyddol") {
      testun = "ui.gwasanaethblynyddol";
    }

    return testun;
  }

  cyfieithuDefnyddiwr(math: string): any {
    let testun = "ui.gwall";

    if (math === "UwchWeinyddwr") {
      testun = "ui.uwchweinyddwr";
    } else if (math === "Gweinyddwr") {
      testun = "ui.gweinyddwr";
    } else if (math === "Yswiriant") {
      testun = "ui.yswiriant";
    } else if (math === "Mecanig") {
      testun = "ui.mecanig";
    } else if (math === "Defnyddiwr") {
      testun = "ui.defnyddiwr";
    } else if (math === "Archwiliwr") {
      testun = "ui.archwiliwr";
    }
    
    return testun;
  }

  // /**
  //  * Toggle newid iaith y LocalizeRouterService
  //  * @param iaith ''cy', 'en'
  //  */
  // lleoleiddioIaith(iaith: string): any {
  //     this.localize.changeLanguage(iaith, { replaceUrl: false });
  // }

  // /**
  // * Setio LOCALIZE_DEFAULT_LANGUAGE
  // * @param iaith ''cy', 'en'
  // */
  // localizeDefaultLanguage(iaith: string): any {
  //     this.storfaDefnyddiwrService.setioEitem('LOCALIZE_DEFAULT_LANGUAGE', iaith);
  // }

  // /**
  //  * Toggle newid iaith y LocalizeRouterService, gan hefyd newid y route / URL
  //  * @param iaith ''cy', 'en'
  //  */
  // newidIaith(iaith: string): any {
  //     this.localize.changeLanguage(iaith, { replaceUrl: true });
  // }

  // /**
  //  * Ar gyfer forcio y URL routing i newid iaith yn gywir.
  //  *
  //  * @sylwadau
  //  * Mae hyn yn cael ei alw fel fod 'cy/cartref' yn newid yn gywir i 'en/home', dim 'en/cartref' ar ôl mewngofnodi.
  //  *
  //  * */
  // lleoleiddioCychwynnol(): any {

  //     const iaithStorfa = this.storfaDefnyddiwrService.nolEitem('iaith');

  //     // Default yr ap ydi hwn
  //     let iaithIwNewid = environment.iaith.cymraeg;

  //     if (iaithStorfa !== environment.iaith.cymraeg) {
  //         iaithIwNewid = iaithStorfa;
  //     }

  //     this.initializeIaith(iaithIwNewid);

  //     this.newidIaith(iaithIwNewid);
  // }

  // /**
  //  *
  //  * @param route Nol y route yn y iaith sydd wedi ei setio rwan
  //  * @returns route
  //  */
  // cyfieithuLlwybr(route: string): string | any {
  //     return this.localize.translateRoute(route);
  // }

  cyfieithuMathOpsiwn(math: string): any {
    let testun = math;

    switch (math) {
      case "Cyffredin": {
        testun = "ui.cyffredin";
        break;
      }
      case "Dosbarth": {
        testun = "ui.dosbarth";
        break;
      }
      case "Gweithredwr": {
        testun = "ui.gweithredwr";
        break;
      }
      case "Atgyweirio": {
        testun = "ui.atgyweirio";
        break;
      }
      case "AtgyweirioAchos": {
        testun = "ui.atgyweirioachos";
        break;
      }
      case "AtgyweirioDosbarth": {
        testun = "ui.atgyweiriodosbarth";
        break;
      }
      case "Gweithdy": {
        testun = "ui.gweithdy";
        break;
      }
      case "Tanwydd": {
        testun = "ui.tanwydd";
        break;
      }
      case "CostauLlafur": {
        testun = "ui.costaullafur";
        break;
      }
      case "CodauAtgyweirio": {
        testun = "ui.codauatgyweirio";
        break;
      }
      case "CodBar": {
        testun = "ui.codbar";
        break;
      }
      case "Depo": {
        testun = "ui.depo";
        break;
      }
      case "Gwneuthurwr": {
        testun = "ui.gwneuthurwr";
        break;
      }
      case "Model": {
        testun = "ui.model";
        break;
      }
      case "Lliw": {
        testun = "ui.lliw";
        break;
      }
      case "Cyflenwr": {
        testun = "ui.cyflenwr";
        break;
      }
      case "Trawsyriant": {
        testun = "ui.trawsyriant";
        break;
      }
      case "Perchennog": {
        testun = "ui.perchennog";
        break;
      }
      case "Tacograff": {
        testun = "ui.tacograff";
        break;
      }
      case "PerchnogaethCerbyd": {
        testun = "ui.perchnogaethcerbyd";
        break;
      }
      case "Tywydd": {
        testun = "ui.tywydd";
        break;
      }
      case "CyflymderUchaf": {
        testun = "ui.cyflymderuchaf";
        break;
      }
      case "Categori": {
        testun = "ui.categori";
        break;
      }
      case "Gwerthu": {
        testun = "ui.gwerthu";
        break;
      }
      case "Odometer": {
        testun = "ui.odometer";
        break;
      }
      case "StatwsGwaith": {
        testun = "ui.statwsgwaith";
        break;
      }
      case "CostauSylfaenol": {
        testun = "ui.costausylfaenol";
        break;
      }
      case "StatwsArchebStoc": {
        testun = "ui.statwsarchebstoc";
        break;
      }
      case "MathCerbyd": {
        testun = "ui.mathcerbyd";
        break;
      }
      case "DisgwylDarn": {
        testun = "ui.disgwyldarn";
        break;
      }
      case "CodMarcio": {
        testun = "ui.codmarcio";
        break;
      }
      case "RhifLlawlyfrArolygu": {
        testun = "ui.rhifllawlyfrarolygu";
        break;
      }
      case "CyflwrLlwythog": {
        testun = "ui.cyflwrllwythog";
        break;
      }
      case "MathMaesDiogelwch": {
        testun = "ui.mathmaesdiogelwch";
        break;
      }
      case "UnedPellter": {
        testun = "ui.unedpellter";
        break;
      }
      case "WediNeud": {
        testun = "ui.wedineud";
        break;
      }
      case "Amserlennu": {
        testun = "ui.amserlennu";
        break;
      }
      case "MathGwaithIsContractwr": {
        testun = "ui.mathgwaithiscontractwr";
        break;
      }
      case "StatwsDamwain": {
        testun = "ui.statwsdamwain";
        break;
      }
      case "KmNeuOriau": {
        testun = "ui.kmneuoriau";
        break;
      }
      case "MathArcheb": {
        testun = "ui.matharcheb";
        break;
      }
      case "ArchebHurio": {
        testun = "ui.archebhurio";
        break;
      }
      case "RheswmDadHurio": {
        testun = "ui.rheswmdadhurio";
        break;
      }
      case "MathCyflenwr": {
        testun = "ui.mathcyflenwr";
        break;
      }
      case "StatwsArchebCerbyd": {
        testun = "ui.statwsarchebcerbyd";
        break;
      }
      case "StatwsArchebArall": {
        testun = "ui.statwsarchebarall";
        break;
      }
      case "CyswlltCerbyd": {
        testun = "ui.cyswlltcerbyd";
        break;
      }
      case "MathStoc": {
        testun = "ui.mathstoc";
        break;
      }
      case "CwmniLoler": {
        testun = "ui.cwmniloler";
        break;
      }
      default: {
        testun = math;
        break;
      }
    }

    return testun;
  }
}
